export const formatPrice = (amount: number): string => {
    return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "XOF",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    })
        .format(amount)
        .replace(/\s(?=\d{3})/g, ".") 
        .replace(/\s?F\s?CFA/, " Fcfa")
        .trim();
};
